import { ref, computed } from "vue";
import {
  subscriptionsApi,
  importanceMapping,
  periodToFrequency,
  frequencyToPeriod,
} from "@/composables/api/subscriptions.api.js";
import { useStore } from "@/store";
import {useProjects} from "@/store/projects";
// eslint-disable-next-line no-unused-vars
import { t } from "@/controllerLK/GlobusLocalization";

// Рубрики для выбора (загружаются из localStorage)
const availableTopics = ref([]);

// ID Таймера проверки авторизации ТГ.
let telegramAuthenticationTimerId = null;


// Опции частоты отчётов (функция для ленивой инициализации, чтобы избежать вызова t() до инициализации Pinia)
export const getFrequencyOptions = () => [
  { value: "immediately", label: t("telegram_subscription.frequency.immediately") || "Сразу" },
  { value: "every_3h", label: t("telegram_subscription.frequency.every_3h") || "Каждые 3 часа" },
  { value: "every_6h", label: t("telegram_subscription.frequency.every_6h") || "Каждые 6 часов" },
  { value: "every_24h", label: t("telegram_subscription.frequency.every_24h") || "Каждые 24 часа" },
  { value: "weekly", label: t("telegram_subscription.frequency.weekly") || "Еженедельно" },
];

// Опции времени отправки для периодических отчётов
export const sendTimeOptions = {
  every_3h: [{
      value: ["06:00:00", "09:00:00", "12:00:00", "15:00:00", "18:00:00", "21:00:00", "00:00:00", "03:00:00"],
      label: "6:00/09:00/12:00/15:00/18:00/21:00/0:00/3:00"
    }, {
      value: ["07:00:00", "10:00:00", "13:00:00", "16:00:00", "19:00:00", "22:00:00", "01:00:00", "04:00:00"],
      label: "7:00/10:00/13:00/16:00/19:00/22:00/01:00/4:00"
    }, {
      value: ["08:00:00", "11:00:00", "14:00:00", "17:00:00", "20:00:00", "23:00:00", "02:00:00", "05:00:00"],
      label: "8:00/11:00/14:00/17:00/20:00/23:00/2:00/5:00"
    }
  ],
  every_6h: [
    { value: ["06:00:00", "12:00:00", "18:00:00", "00:00:00"], label: "6:00/12:00/18:00/0:00" },
    { value: ["07:00:00", "13:00:00", "19:00:00", "01:00:00"], label: "7:00/13:00/19:00/1:00" },
    { value: ["08:00:00", "14:00:00", "20:00:00", "02:00:00"], label: "8:00/14:00/20:00/2:00" },
    { value: ["09:00:00", "15:00:00", "21:00:00", "03:00:00"], label: "9:00/15:00/21:00/3:00" },
    { value: ["10:00:00", "16:00:00", "22:00:00", "04:00:00"], label: "10:00/16:00/22:00/4:00" },
    { value: ["11:00:00", "17:00:00", "23:00:00", "05:00:00"], label: "11:00/17:00/23:00/5:00" },
  ],
  every_24h: [
    { value: ["06:00:00"], label: "6:00" },
    { value: ["07:00:00"], label: "7:00" },
    { value: ["08:00:00"], label: "8:00" },
    { value: ["09:00:00"], label: "9:00" },
    { value: ["10:00:00"], label: "10:00" },
    { value: ["11:00:00"], label: "11:00" },
    { value: ["12:00:00"], label: "12:00" },
    { value: ["13:00:00"], label: "13:00" },
    { value: ["14:00:00"], label: "14:00" },
    { value: ["15:00:00"], label: "15:00" },
    { value: ["16:00:00"], label: "16:00" },
    { value: ["17:00:00"], label: "17:00" },
    { value: ["18:00:00"], label: "18:00" },
    { value: ["19:00:00"], label: "19:00" },
    { value: ["20:00:00"], label: "20:00" },
    { value: ["21:00:00"], label: "21:00" },
    { value: ["22:00:00"], label: "22:00" },
    { value: ["23:00:00"], label: "23:00" },
    { value: ["00:00:00"], label: "0:00" },
    { value: ["01:00:00"], label: "1:00" },
    { value: ["02:00:00"], label: "2:00" },
    { value: ["03:00:00"], label: "3:00" },
    { value: ["04:00:00"], label: "4:00" },
    { value: ["05:00:00"], label: "5:00" },
  ],
  weekly: [
    { value: ["06:00:00"], label: "6:00" },
    { value: ["07:00:00"], label: "7:00" },
    { value: ["08:00:00"], label: "8:00" },
    { value: ["09:00:00"], label: "9:00" },
    { value: ["10:00:00"], label: "10:00" },
    { value: ["11:00:00"], label: "11:00" },
    { value: ["12:00:00"], label: "12:00" },
    { value: ["13:00:00"], label: "13:00" },
    { value: ["14:00:00"], label: "14:00" },
    { value: ["15:00:00"], label: "15:00" },
    { value: ["16:00:00"], label: "16:00" },
    { value: ["17:00:00"], label: "17:00" },
    { value: ["18:00:00"], label: "18:00" },
    { value: ["19:00:00"], label: "19:00" },
    { value: ["20:00:00"], label: "20:00" },
    { value: ["21:00:00"], label: "21:00" },
    { value: ["22:00:00"], label: "22:00" },
    { value: ["23:00:00"], label: "23:00" },
    { value: ["00:00:00"], label: "0:00" },
    { value: ["01:00:00"], label: "1:00" },
    { value: ["02:00:00"], label: "2:00" },
    { value: ["03:00:00"], label: "3:00" },
    { value: ["04:00:00"], label: "4:00" },
    { value: ["05:00:00"], label: "5:00" },
  ],
};

// Опции дней недели (для еженедельной рассылки)
export const getWeekdayOptions = () => [
  { value: "monday", label: t("telegram_subscription.weekdays.monday") || "Понедельник" },
  { value: "tuesday", label: t("telegram_subscription.weekdays.tuesday") || "Вторник" },
  { value: "wednesday", label: t("telegram_subscription.weekdays.wednesday") || "Среда" },
  { value: "thursday", label: t("telegram_subscription.weekdays.thursday") || "Четверг" },
  { value: "friday", label: t("telegram_subscription.weekdays.friday") || "Пятница" },
  { value: "saturday", label: t("telegram_subscription.weekdays.saturday") || "Суббота" },
  { value: "sunday", label: t("telegram_subscription.weekdays.sunday") || "Воскресенье" },
];

// Опции часовых поясов
export const timezoneOptions = [
  { value: "Etc/GMT-12", label: "UTC -12:00" },
  { value: "Etc/GMT-11", label: "UTC -11:00" },
  { value: "Etc/GMT-10", label: "UTC -10:00" },
  { value: "Etc/GMT-9",  label: "UTC -09:00" },
  { value: "Etc/GMT-8",  label: "UTC -08:00" },
  { value: "Etc/GMT-7",  label: "UTC -07:00" },
  { value: "Etc/GMT-6",  label: "UTC -06:00" },
  { value: "Etc/GMT-5",  label: "UTC -05:00" },
  { value: "Etc/GMT-4",  label: "UTC -04:00" },
  { value: "Etc/GMT-3",  label: "UTC -03:00" },
  { value: "Etc/GMT-2",  label: "UTC -02:00" },
  { value: "Etc/GMT-1",  label: "UTC -01:00" },

  { value: "UTC",        label: "UTC +00:00" },

  { value: "Etc/GMT+1",  label: "UTC +01:00" },
  { value: "Etc/GMT+2",  label: "UTC +02:00" },
  { value: "Etc/GMT+3",  label: "UTC +03:00" },
  { value: "Etc/GMT+4",  label: "UTC +04:00" },
  { value: "Etc/GMT+5",  label: "UTC +05:00" },
  { value: "Etc/GMT+6",  label: "UTC +06:00" },
  { value: "Etc/GMT+7",  label: "UTC +07:00" },
  { value: "Etc/GMT+8",  label: "UTC +08:00" },
  { value: "Etc/GMT+9",  label: "UTC +09:00" },
  { value: "Etc/GMT+10", label: "UTC +10:00" },
  { value: "Etc/GMT+11", label: "UTC +11:00" },
  { value: "Etc/GMT+12", label: "UTC +12:00" },
  { value: "Etc/GMT+13", label: "UTC +13:00" },
  { value: "Etc/GMT+14", label: "UTC +14:00" },
];

// Опции значимости (функция для ленивой инициализации)
export const getImportanceOptions = () => [
  { value: "critical", label: t("telegram_subscription.importance.critical"), color: "#FA665C" },
  { value: "important", label: t("telegram_subscription.importance.important"), color: "#FF9067" },
  { value: "moderate", label: t("telegram_subscription.importance.moderately"), color: "#FFE767" },
  { value: "interesting", label: t("telegram_subscription.importance.not_critical"), color: "#C4F487" },
];

// Опции тональности (функция для ленивой инициализации)
export const getTonalityOptions = () => [
  { value: "negative", label: t("telegram_subscription.sentiment.negative"), color: "#FA665C" },
  { value: "neutral", label: t("telegram_subscription.sentiment.neutral"), color: "#7B87A5" },
  { value: "positive", label: t("telegram_subscription.sentiment.positive"), color: "#63D63B" },
];

// Список возможных ошибок
const errorList = {
  // Критичность должна быть заполнена
  importanceRequired: false,
  // Тональность должна быть заполнена
  tonalityRequired: false,
  // Для отображения общей ошибки по тональности и критичности
  importanceTonalityRequired: false,
  // Должна быть выбрана как минимум 1 тема.
  selectedTopicsRequired: false,
  serverError: false,
};

/**
 * Преобразование правила из формата API во внутренний формат
 */
function mapSubscriptionToRule(subscription) {
  // Преобразование importance из API формата
  const importanceMap = {
    normal: ["interesting"],
    gently_important: ["moderate"],
    important: ["important"],
    critical: ["critical"],
  };
  
  const importance = [];
  if (subscription.importance) {
    subscription.importance.forEach((imp) => {
      if (importanceMap[imp]) {
        importance.push(...importanceMap[imp]);
      }
    });
  }

  return {
    id: subscription.id,
    subscriptionId: subscription.id, // UUID для API
    userId: subscription.user_id,
    isDefault: false,
    selectedTopics: subscription.rubric_ids.map((id) => id) || [],
    frequency: periodToFrequency(subscription.newsletter_settings.period),
    sendTime: subscription.newsletter_settings.newsletter_time || [],
    weekday: subscription.newsletter_settings.weekday || "monday",
    timezone: subscription.newsletter_settings.time_zone || "UTC",
    importance: importance.length > 0 ? importance : ["important", "critical"],
    tonality: subscription.sentiment || ["negative"],
    errorList: { ...errorList}
  };
}

export const verifySubscription = async () => {
  const store = useStore();

  try {
    const response = await subscriptionsApi.verifySubscription();
    const result = response?.subscribed || false;
    store.isTelegramAuthorized = result;
    return result;
  } catch (e) {
    store.isTelegramAuthorized = false;
    store.createNotify(t("notification.subscriptions.get_verify_error"), "error");
    console.error(e);
    return false;
  }
};

export function useTelegramRules(projectId = null) {
  const mainStore = useStore();
  
  const verified = ref(mainStore.isTelegramAuthorized);
  const rules = ref([]);
  const originalRules = ref({}); // Хранит исходное состояние правил для отслеживания изменений
  const deletedRules = ref([]); // Хранит удалённые правила для отложенного удаления на сервере
  const isLoading = ref(false);
  const currentProjectId = ref(projectId);
  const projectStore = useProjects();
  const recursivelyVerifying = ref(false);

  const topicSearchQuery = ref("");

  // Загрузка данных.
  const initTelegramRules = async (newProjectId = null) => {
    const targetProjectId = newProjectId ?? projectId;
    if (targetProjectId) {
      currentProjectId.value = targetProjectId;
    }

    if (!currentProjectId.value) {
      availableTopics.value = [];
      return;
    }

    isLoading.value = true;

    // Загружаем список тем для существующего проекта
    availableTopics.value = await projectStore.getProjectRubrics(currentProjectId.value);
    // Загрузка списка правил, если пользователь подписан на бота.
    if (verified.value) {
      await loadSubscriptions();
    }
    isLoading.value = false;
  };

  const filteredTopics = computed(() => {
    if (!topicSearchQuery.value) {
      return availableTopics.value;
    }
    return availableTopics.value.filter((t) =>
      t.name.toLowerCase().includes(topicSearchQuery.value.toLowerCase())
    );
  });

  //* Рекурсивная проверка подписки с задержкой
  const verifySubscriptionRecursively = async (delay = 2000) => {
    // Устанавливаем флаг только при первом вызове
    if (!recursivelyVerifying.value) {
      recursivelyVerifying.value = true;
    }
    isLoading.value = true;

    try {
      verified.value = (await subscriptionsApi.verifySubscription()).subscribed || false;
    } catch (e) {
      console.log(e);
    }

    
    if (!verified.value && recursivelyVerifying.value) {
      telegramAuthenticationTimerId = setTimeout(() => {
        verifySubscriptionRecursively(delay);
      }, delay);
    } else {
      recursivelyVerifying.value = false;
      isLoading.value = false;
    }
  };

  const stopRecursiveVerification = () => {
    if (telegramAuthenticationTimerId) {
      clearTimeout(telegramAuthenticationTimerId);
      telegramAuthenticationTimerId = null;
    }

    recursivelyVerifying.value = false;
    verified.value = false;
    isLoading.value = false;
  };

  /**
   * Создать снимок правила для сравнения
   */
  const createRuleSnapshot = (rule) => ({
    selectedTopics: [...rule.selectedTopics].sort((a, b) => a - b),
    frequency: rule.frequency,
    sendTime: [...rule.sendTime].sort(),
    weekday: rule.weekday,
    timezone: rule.timezone,
    importance: [...rule.importance].sort(),
    tonality: [...rule.tonality].sort(),
  });

  /**
   * Сохранить снимок правила в originalRules
   */
  const saveRuleSnapshot = (rule) => {
    if (rule.subscriptionId) {
      originalRules.value[rule.subscriptionId] = createRuleSnapshot(rule);
    }
  };

  /**
   * Проверить, изменилось ли правило относительно оригинала
   */
  const isRuleChanged = (rule) => {
    // Новые правила всегда считаются "изменёнными"
    if (!rule.subscriptionId) {
      return true;
    }

    const original = originalRules.value[rule.subscriptionId];
    if (!original) {
      return true; // Нет оригинала - считаем изменённым
    }

    const current = createRuleSnapshot(rule);

    // Сравниваем все поля
    return (
      JSON.stringify(current.selectedTopics) !== JSON.stringify(original.selectedTopics) ||
      current.frequency !== original.frequency ||
      JSON.stringify(current.sendTime) !== JSON.stringify(original.sendTime) ||
      current.weekday !== original.weekday ||
      current.timezone !== original.timezone ||
      JSON.stringify(current.importance) !== JSON.stringify(original.importance) ||
      JSON.stringify(current.tonality) !== JSON.stringify(original.tonality)
    );
  };

  /**
   * Загрузить подписки с сервера
   */
  const loadSubscriptions = async () => {
    try {
      const params = {
        project_id: currentProjectId.value,
        page: 1,
        limit: 100,
      };
      rules.value = [];
      const subscriptions = (await subscriptionsApi.getSubscriptions(params)).items;
      
      // Преобразуем подписки во внутренний формат
      if (subscriptions && subscriptions.length > 0) {
        rules.value = subscriptions.map(mapSubscriptionToRule);
        // Сохраняем снимки загруженных правил
        originalRules.value = {};
        rules.value.forEach(saveRuleSnapshot);
      } else {
        // Создаём правило по умолчанию, если нет подписок
        // rules.value = [createDefaultRule()];
        originalRules.value = {};
      }
    } catch (error) {
      console.error("Ошибка загрузки подписок:", error);
      mainStore.createNotify("Ошибка загрузки настроек уведомлений", "error");
      // Создаём правило по умолчанию при ошибке
      // rules.value = [createDefaultRule()];
    }
  };

  /**
   * Установить ID проекта и загрузить подписки
   */
  const setProjectId = async (id) => {
    currentProjectId.value = id;
    await loadSubscriptions();
  };

  /**
   * Установить доступные темы (рубрики) проекта
   */
  const setAvailableTopics = (topics) => {
    availableTopics.value = topics;
  };

  /**
   * Создать правило по умолчанию
   */
  // eslint-disable-next-line no-unused-vars
  const createDefaultRule = () => ({
    id: Date.now(),
    subscriptionId: null,
    isDefault: true,
    selectedTopics: availableTopics.value.map((topic) => topic.id) || [],
    frequency: "immediately",
    sendTime: [],
    weekday: "monday",
    timezone: "UTC",
    importance: ["interesting", "moderate", "important", "critical"],
    tonality: ["negative", "neutral", "positive"],
    error: null,
    errorList: { ...errorList}
  });

  // Получить label для выбора темы
  const getTopicsLabel = (rule) => {
    if (rule.selectedTopics.length === 0) {
      return "всех тем проекта";
    }
    const names = rule.selectedTopics.map(
      (id) => availableTopics.value.find((t) => t.id === id)?.name
    );
    if (names.length <= 3) {
      return names.join(", ");
    }
    return names.slice(0, 3).join(", ") + "...";
  };

  // Получить количество дополнительных тем
  const getExtraTopicsCount = (rule) => {
    if (rule.selectedTopics.length > 3) {
      return rule.selectedTopics.length - 3;
    }
    return 0;
  };

  // Получить label частоты
  const getFrequencyLabel = (frequency) => {
    return getFrequencyOptions().find((f) => f.value === frequency)?.label || "";
  };

  // Проверить, нужно ли показывать время отправки
  const showSendTime = (frequency) => {
    return ["every_3h", "every_6h", "every_24h", "weekly"].includes(frequency);
  };

  // Добавить новое правило (локально, без сохранения на сервер)
  const addRule = () => {
    const newRule = {
      id: Date.now(),
      subscriptionId: null,
      isDefault: false,
      selectedTopics: availableTopics.value.map((topic) => topic.id) || [],
      frequency: "immediately",
      sendTime: [],
      weekday: "monday",
      timezone: "UTC",
      importance: ["interesting", "moderate", "important", "critical"],
      tonality: ["negative", "neutral", "positive"],
      isNew: true, // Флаг для отслеживания новых правил
      error: null,
      errorList: errorList
    };
    rules.value.push(newRule);
    return newRule;
  };

  // Удалить правило (локально, без запроса на сервер)
  const deleteRule = (ruleId) => {
    const index = rules.value.findIndex((r) => r.id === ruleId);
    if (index > -1) {
      const rule = rules.value[index];

      // Если правило было сохранено на сервере, добавляем его в список для отложенного удаления
      if (rule.subscriptionId) {
        deletedRules.value.push(rule);
      }

      rules.value.splice(index, 1);
    }
  };

  /**
   * Преобразование правила из внутреннего формата в формат API
   */
  function mapRuleToSubscription(rule, project_id) {
    // Преобразование importance во внутренний формат API
    const importanceSet = new Set();
    rule.importance.forEach((imp) => {
      const mapped = importanceMapping[imp];
      if (mapped) {
        importanceSet.add(mapped);
      }
    });    

    return {
      project_id: project_id,
      rubric_ids: rule.selectedTopics.length > 0 ? rule.selectedTopics.map(id => Number(id)) : [],
      importance: Array.from(importanceSet),
      sentiment: rule.tonality,
      newsletter_settings: {
        period: frequencyToPeriod(rule.frequency),
        time_zone: rule.timezone,
        newsletter_time: rule.sendTime,
        weekday: rule.weekday,
      },
    };
  }

  /**
   * Сохранить правило на сервер
   */
  const saveRule = async (rule, project_id) => {
    const subscriptionData = mapRuleToSubscription(rule, project_id);

    try {
      if (rule.subscriptionId) {
        // Обновление существующей подписки
        await subscriptionsApi.updateSubscription(rule.subscriptionId, subscriptionData);
        // mainStore.createNotify(t("telegram_subscription.notifications.success_update"), "success");
      } else {
        // Создание новой подписки
        const created = await subscriptionsApi.createSubscription(subscriptionData);
        rule.subscriptionId = created.id;
        rule.isNew = false;
        // mainStore.createNotify(t("telegram_subscription.notifications.success_create"), "success");
      }
      return rule;
    } catch (error) {
      console.error(t("telegram_subscription.notifications.error_save"), error);
      rule.errorList.serverError = true;
      mainStore.createNotify(t("telegram_subscription.notifications.error_save"), "error");
      return null;
    }
  };

  // Валидация всех существующих правил проекта.
  const validateRules = () => {
    let hasErrors = false;

    for (const rule of rules.value) {
      const isValid = validateRule(rule);

      // Если правило невалидно, отмечаем наличие ошибок
      if (!isValid) {
        hasErrors = true;
      }
    }

    // Возвращаем true, если ошибок нет
    return !hasErrors;
  };
  // Валидация переданного правила с мутацией исходного объекта.
  // False - В правиле есть ошибки.
  // True - Правило составлено верно.
  const validateRule = (rule) => {
    if (!rule) {
      return false;
    }

    // Создаём объект ошибок
    const errors = {
      importanceRequired: !rule.importance || rule.importance.length === 0,
      tonalityRequired: !rule.tonality || rule.tonality.length === 0,
      selectedTopicsRequired: !rule.selectedTopics || rule.selectedTopics.length === 0,
      importanceTonalityRequired: false
    };

    // Комбинированная проверка для отображения общего уведомления ошибки тональности/критичности
    errors.importanceTonalityRequired =
        errors.importanceRequired && errors.tonalityRequired;

    // Замена ошибок в правиле.
    rule.errorList = errors;

    // Возвращаем результат валидации
    return !Object.values(errors).some(Boolean);
  };

  /**
   * Очистить ошибку у правила
   */
  const clearRuleError = (ruleId) => {
    const rule = rules.value.find((r) => r.id === ruleId);
    if (rule) {
      rule.error = null;
    }
  };

  /**
   * Сохранить все правила на сервер (только новые или изменённые)
   */
  const saveAllRules = async (project_id) => {
    // Фильтруем только новые или изменённые правила
    const rulesToSave = rules.value.filter(isRuleChanged);

    // Если нет изменений
    if (rulesToSave.length === 0) {
      return true;
    }

    isLoading.value = true;
    const results = [];

    for (const rule of rulesToSave) {
      const result = await saveRule(rule, project_id);
      results.push(result);

      // После успешного сохранения обновляем снимок
      if (result) {
        saveRuleSnapshot(rule);
      }
    }

    isLoading.value = false;
    return results.every((r) => r !== null);
  };

  /**
   * Удалить все правила (подписки) с сервера
   */
  const deleteAllRules = async () => {
    isLoading.value = true;
    let allDeleted = true;
    
    // Удаляем только правила, которые сохранены на сервере (имеют subscriptionId)
    const rulesToDelete = rules.value.filter(rule => rule.subscriptionId);
    
    for (const rule of rulesToDelete) {
      try {
        await subscriptionsApi.deleteSubscription(rule.subscriptionId);
      } catch (error) {
        console.error(t("telegram_subscription.notifications.error_delete_some"), error);
        allDeleted = false;
      }
    }
    
    if (allDeleted) {
      rules.value = [];
      mainStore.createNotify(t("telegram_subscription.notifications.success_delete_all"), "success");
    } else {
      mainStore.createNotify(t("telegram_subscription.notifications.error_delete_some"), "error");
    }
    
    isLoading.value = false;
    return allDeleted;
  };

  /**
   * Удалить помеченные для удаления правила с сервера
   * Вызывается после saveAllRules в createProject
   * @returns {Promise<boolean>} true если все удаления успешны
   */
  const deleteMarkedRules = async () => {
    if (deletedRules.value.length === 0) {
      return true;
    }

    isLoading.value = true;
    let allDeleted = true;
    const successfullyDeleted = [];

    for (const rule of deletedRules.value) {
      try {
        await subscriptionsApi.deleteSubscription(rule.subscriptionId);
        successfullyDeleted.push(rule.subscriptionId);
      } catch (error) {
        console.error("Ошибка удаления правила:", error);
        // Возвращаем правило в локальный список с ошибкой
        rule.errorList = { ...rule.errorList, serverError: true };
        rules.value.push(rule);
        allDeleted = false;
      }
    }

    // Удаляем успешно удалённые правила из deletedRules
    deletedRules.value = deletedRules.value.filter(
      (rule) => !successfullyDeleted.includes(rule.subscriptionId)
    );

    if (!allDeleted) {
      mainStore.createNotify(t("telegram_subscription.notifications.error_delete_some"), "error");
    }

    isLoading.value = false;
    return allDeleted;
  };

  /**
   * Сбросить список удалённых правил и вернуть их в локальный список
   * Вызывается при закрытии модалки без сохранения
   */
  const resetDeletedRules = () => {
    if (deletedRules.value.length > 0) {
      rules.value.push(...deletedRules.value);
      deletedRules.value = [];
    }
  };

  // Toggle значимость
  const toggleImportance = (rule, value) => {
    const index = rule.importance.indexOf(value);
    if (index > -1) {
      rule.importance.splice(index, 1);
    } else {
      rule.importance.push(value);
    }
    validateRule(rule);
  };

  // Toggle тональность
  const toggleTonality = (rule, value) => {
    const index = rule.tonality.indexOf(value);
    if (index > -1) {
      rule.tonality.splice(index, 1);
    } else {
      rule.tonality.push(value);
    }
    validateRule(rule);
  };

  // Toggle тема
  const toggleTopic = (rule, topicId) => {
    const index = rule.selectedTopics.indexOf(topicId);
    if (index > -1) {
      rule.selectedTopics.splice(index, 1);
    } else {
      rule.selectedTopics.push(topicId);
    }
    validateRule(rule);
  };

  // Выбрать все темы
  const toggleAllTopics = (rule) => {
    if (rule.selectedTopics.length === availableTopics.value.length) {
      rule.selectedTopics = [];
    } else {
      rule.selectedTopics = availableTopics.value.map((t) => t.id);
    }

    validateRule(rule);
  };

  // Получить выбранные цвета значимости
  const getSelectedImportanceColors = (rule) => {
    return getImportanceOptions()
      .filter((opt) => rule.importance.includes(opt.value))
      .map((opt) => opt.color);
  };

  // Получить выбранные тональности
  const getSelectedTonalities = (rule) => {
    return getTonalityOptions().filter((opt) => rule.tonality.includes(opt.value));
  };

  // Проверка наличия ошибок валидации в правилах
  const hasErrors = computed(() => {
    return rules.value.some(rule =>
      rule.errorList && Object.values(rule.errorList).some(Boolean)
    );
  });

  /**
   * Отвязать Telegram-чат пользователя
   */
  const unlinkTelegramChat = async () => {
    try {
      await subscriptionsApi.unlinkTelegramChat();
      mainStore.createNotify(t("telegram_subscription.notifications.success_unlink"), "success");
      return true;
    } catch (error) {
      console.error("Ошибка отвязки Telegram-чата:", error);
      mainStore.createNotify(t("telegram_subscription.notifications.error_unlink"), "error");
      return false;
    }
  };

  return {
    initTelegramRules,
    verified,
    verifySubscriptionRecursively,
    recursivelyVerifying,
    stopRecursiveVerification,
    rules,
    isLoading,
    availableTopics,
    topicSearchQuery,
    filteredTopics,
    currentProjectId,
    // Методы загрузки/сохранения
    loadSubscriptions,
    setProjectId,
    setAvailableTopics,
    saveRule,
    saveAllRules,
    deleteAllRules,
    deleteMarkedRules,
    resetDeletedRules,
    unlinkTelegramChat,
    // Валидация
    validateRules,
    hasErrors,
    clearRuleError,
    // Методы работы с правилами
    getTopicsLabel,
    getExtraTopicsCount,
    getFrequencyLabel,
    showSendTime,
    addRule,
    deleteRule,
    toggleImportance,
    toggleTonality,
    toggleTopic,
    toggleAllTopics,
    getSelectedImportanceColors,
    getSelectedTonalities,
  };
}
